export default "__VITE_ASSET__C3NJszN2__"